import FaqDetailContent from './faq-detail-content';

export default FaqDetailContent;
